<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<mat-toolbar>GSPT Query</mat-toolbar>
<div matDialogContent class="dash-gis-gspt-container" fxLayout="column" fxLayoutAlign="space-between start">
  <form [formGroup]="gsptForm" (ngSubmit)="doTrace()">
    <div fxLayout="column">
      <mat-form-field>
        <mat-label>Distance</mat-label>
        <input matInput
          name="distance"
          formControlName="distance">
        <mat-hint>Leave blank for maximum</mat-hint>
      </mat-form-field>
      <mat-radio-group formControlName="direction" fxLayout="column">
        <mat-radio-button value="up">Upstream</mat-radio-button>
        <mat-radio-button value="down">Downstream</mat-radio-button>
      </mat-radio-group>
      @if (gsptForm.controls['direction'].invalid && (gsptForm.controls['direction'].dirty || gsptForm.controls['direction'].touched)) {
        <div
          class="alert alert-danger">
          @if (gsptForm.controls['direction'].errors.required) {
            <div>You must choose a direction.</div>
          }
        </div>
      }
    </div>

    <mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
      <button mat-button type="button" (click)="cancel()">Cancel</button>
      <button mat-button type="submit" [disabled]="gsptForm.invalid">Trace</button>
    </mat-dialog-actions>
  </form>
</div>
